// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"553":"e76b3586","677":"dbfb1a00","773":"20446585"}[chunkId] + ".chunk.css";
};